<template>
  <div class="layout" :class="{ 'full-chat': isChatPage }">
    
    <div class="main-content">
      <SidebarSystem v-if="!isChatPage"/>

      <div class="page-content">
        <transition name="quick-fade" mode="out-in">
          <router-view :key="$route.fullPath" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarSystem from "@/components/SidebarSystem.vue";

export default {
  name: "MainLayout",

  components: {
    SidebarSystem,
  },
  computed: {
    isChatPage() {
      return this.$route.name === "ChatPage" || this.$route.name === "ChatbotBuilder";
    }
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
/* ========================
   Layout base del componente
======================== */
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f9fafb;
  overflow: hidden;
}

.main-content {
  display: flex;
  flex: 1;
}

.page-content {
  flex: 1;
  overflow-y: auto;
  background: #f9fafb;
  border-left: 1px solid #e0e0e0;
  position: relative;
}

/* ========================
   Logo decorativo central
======================== */
.decorative-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.08; 
}

.logo-gradient {
  width: 350px;
  height: auto;
  border-radius: 50%;
}

/* ========================
   Transiciones de página
======================== */
.quick-fade-enter-active,
.quick-fade-leave-active {
  transition: opacity 0.15s ease;
}

.quick-fade-enter,
.quick-fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.slide-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.slide-fade-enter {
  opacity: 0;
  transform: translateX(30px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* ========================
   Variación de layout si es página de chat
======================== */
.full-chat {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.full-chat .main-content {
  flex: 1;
  display: flex;
}

.full-chat .page-content {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-left: none;
  background: #f9fafb;
}
</style>
